var exports = {
  "kL": "DiscoverySidebar.module__container___a3pxek",
  "CT": "DiscoverySidebar.module__navList___a3pxek",
  "pc": "DiscoverySidebar.module__navItem___a3pxek",
  "HW": "DiscoverySidebar.module__navItemActive___a3pxek",
  "T1": "DiscoverySidebar.module__navItemDisabled___a3pxek",
  "wz": "DiscoverySidebar.module__navItemIcon___a3pxek",
  "hk": "DiscoverySidebar.module__navItemLabel___a3pxek",
  "WG": "DiscoverySidebar.module__comingSoonBadge___a3pxek",
};

module.exports = exports;
